import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import PropTypes from 'prop-types';

import MESSAGES from '../definitions/Messages';


function CardInterestRate({
    interestRate,
    interestRateMax,
    hasVariableInterestRate = false,
    variableClassName,
}) {
    if (interestRate === null || interestRate === undefined) {
        return (
            <span>
                {'N/A'}
                {/* bilingual! */}
            </span>
        );
    }

    return (
        <>
            <FormattedNumber
                value={interestRate / 100}
                format="percent2"
            />
            <Choose>
                <When condition={interestRateMax}>
                    {' – '}
                    {/* that’s an en dash, btw */}
                    <FormattedNumber
                        value={interestRateMax / 100}
                        format="percent2"
                    />
                </When>
                <Otherwise>
                    <If condition={hasVariableInterestRate}>
                        <span className={variableClassName}>
                            <FormattedMessage
                                {...MESSAGES.variableCardInterestSuffix}
                            />
                        </span>
                    </If>
                </Otherwise>
            </Choose>
        </>
    );
}

CardInterestRate.propTypes = {
    interestRate: PropTypes.number,
    interestRateMax: PropTypes.number,
    hasVariableInterestRate: PropTypes.bool,
    variableClassName: PropTypes.string,
};


export default CardInterestRate;
